import React from 'react';
import Hero from '../components/Hero';
import BrandAgentExplanation from '../components/BrandAgentExplanation';
import Services from '../components/Services';
import AboutTeaser from '../components/AboutTeaser';
import FAQ from '../components/FAQ';
import CTA from '../components/CTA';
import ContactSection from '../components/ContactSection';
import { usePageMeta } from '../hooks/usePageMeta';
import { organizationLd, websiteLd, serviceLd, faqLd } from '../lib/schema';
import { fi as fiCopy } from '../contexts/LanguageContext';

// FAQ JSON-LD is derived from the SAME source as the visible FAQ component
const homeFaqLd = faqLd(
  fiCopy.faq.items.map((item) => ({ q: item.question, a: item.answer }))
);

const Home = () => {
  usePageMeta({
    title: 'Agencive – Brändiagentteja yrityksille',
    description:
      'Agencive luo yrityksellesi brändipersoonan somesisältöihin ja samaan persoonaan perustuvan AI-agentin nykyiselle verkkosivustollesi.',
    path: '/',
    jsonLd: [organizationLd, websiteLd, serviceLd, homeFaqLd],
  });

  return (
    <main className="bg-bg">
      <Hero />
      <BrandAgentExplanation />
      <Services />
      <AboutTeaser />
      <FAQ />
      <CTA />
      <ContactSection />
    </main>
  );
};

export default Home;
